import AdminHeader from "components/Headers/AdminHeader";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Input,
  Label,
  Tooltip,
  CardFooter,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { REGEX } from "constants/CommonConstants";
import Avatar from "components/CommonComponents/Avatar";
import { SELECT_CUSTOM_STYLES } from "constants/CommonConstants";
import { GENDER_OPTIONS } from "components/constant";
import {
  getInstructorProfileDetails,
  updateInstructorProfileDetails,
} from "action/instructor";

const instructorProfileData = {
  firstName: {
    value: "",
    error: "",
  },

  lastName: {
    value: "",
    error: "",
  },

  fullName: {
    value: "",
    error: "",
  },

  email: {
    value: "",
    error: "",
  },

  mobile: {
    value: "",
    error: "",
  },
  profilePhoto: {
    value: "",
    error: "",
  },

  gender: {
    value: "",
    error: "",
  },

  experienceYears: {
    value: "",
    error: "",
  },

  accountStatus: {
    value: "",
  },

  createdOn: {
    value: "",
  },
};

function InstructorProfile() {
  const [formData, setFormData] = useState(instructorProfileData);
  const [profileState, setProfileState] = useState({
    isEditing: false,
    originalFormData: instructorProfileData,
  });
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const [listState, setListState] = useState({
    isLoading: false,
    error: "",
  });

  const fetchInstructorProfile = async () => {
    try {
      setListState({
        isLoading: true,
        error: "",
      });

      const res = await getInstructorProfileDetails();

      if (res?.code === 200) {
        const data = res?.data;

        const mappedData = {
          firstName: {
            value: data?.user?.firstName || "",
            error: "",
          },

          lastName: {
            value: data?.user?.lastName || "",
            error: "",
          },

          fullName: {
            value: data?.user?.fullName || "",
            error: "",
          },

          email: {
            value: data?.user?.email || "",
            error: "",
          },

          mobile: {
            value: data?.user?.mobile || "",
            error: "",
          },

          profilePhoto: {
            value: data?.user?.profileImagePath || "",
            error: "",
          },

          gender: {
            value: data?.gender || "",
            error: "",
          },
          experienceYears: {
            value: data?.totalExperienceInMonths || 0,
            displayValue: data?.totalExperience || "",
            error: "",
          },

          accountStatus: {
            value: data?.user?.status || "",
          },

          createdOn: {
            value: data?.user?.createdOn || "",
          },
        };

        setFormData(mappedData);
        setListState({
          isLoading: false,
          error: "",
        });

        return;
      }

      setListState({
        isLoading: false,
        error: res?.message || "Failed to load instructor profile",
      });

      return;
    } catch (error) {
      setListState({
        isLoading: false,
        error:
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong while fetching instructor profile",
      });

      return;
    }
  };
  useEffect(() => {
    fetchInstructorProfile();
  }, []);

  const handleChange = (fieldName, newValue) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: {
        ...prev[fieldName],
        value: newValue,
      },
    }));
  };

  const getValidationError = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    switch (name) {
      case "fullName":
        return !trimmedValue
          ? "Please enter first  name"
          : !REGEX.ONLY_ALPHABETS_REGEX.test(trimmedValue)
            ? "First name must contain only letters and spaces"
            : "";
      case "lastName":
        return !trimmedValue
          ? "Please enter last  name"
          : !REGEX.ONLY_ALPHABETS_REGEX.test(trimmedValue)
            ? "Last name must contain only letters and spaces"
            : "";
      case "totalExperience":
        return trimmedValue === "" || trimmedValue === null
          ? "Please enter years of experience"
          : isNaN(trimmedValue)
            ? "Experience must be a number"
            : trimmedValue < 0 || trimmedValue > 40
              ? "Experience must be between 0 and 40 years"
              : "";

      case "skills":
        return !Array.isArray(trimmedValue) || trimmedValue.length === 0
          ? "Please select at least one primary skill"
          : "";

      default:
        return "";
    }
  };

  // const validateForm = () => {
  //   let profileData = { ...formData };

  //   //get all the keys in array
  //   Object.keys(profileData).forEach((key) => {
  //     profileData[key] = {
  //       ...profileData[key],
  //       error: getValidationError(key, profileData[key].value),
  //     };
  //   });
  //   setFormData(profileData); //if error set error state
  //   return Object.values(profileData).every((item) => item.error === "");
  // };

  const handleOnBlur = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const error = getValidationError(name, trimmedValue);
    setFormData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: trimmedValue,
        error,
      },
    }));
  };

const handleSave = async () => {
  try {
    const bodyData = {
      firstName: formData.firstName?.value || "",
      lastName: formData.lastName?.value || "",
      gender: formData.gender?.value || "",
      priorExperienceYears: Number(
        formData.experienceYears?.value || 0
      ),
    };

    const res = await updateInstructorProfileDetails(bodyData);

    if (res?.code === 200) {
      setProfileState((prev) => ({
        ...prev,
        isEditing: false,
      }));

      await fetchInstructorProfile();
    } else {
      setListState({
        isLoading: false,
        error: res?.message || "Failed to update instructor profile",
      });
    }
  } catch (error) {
    setListState({
      isLoading: false,
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong while updating instructor profile",
    });
  }
};
  const handleOnCancel = () => {
    setFormData(profileState.originalFormData);

    setProfileState((prev) => ({
      ...prev,
      isEditing: false,
    }));
  };

  const handleEdit = () => {
    setProfileState((prev) => ({
      ...prev,
      originalFormData: formData,
      isEditing: true,
    }));
  };

  // const removeDocument = (index) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     certificationsDocs: {
  //       value: prev.certificationsDocs.value.filter((_, i) => i !== index),
  //       error: "",
  //     },
  //   }));
  // };

  // const handleImageChange = (file) => {
  //   if (!file) return;
  //   //validate the image size
  //   if (file.size > MAX_FILE_SIZE) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       profile: {
  //         value: null,
  //         error: "Image should not exceed maz size of 2 Mb", // Image should not exceed 2 mb
  //       },
  //     }));
  //     return;
  //   }

  //   setFormData((prev) => ({
  //     ...prev,
  //     profile: {
  //       value: file,
  //       error: "",
  //     },
  //   }));
  // };

  return (
    <>
      <AdminHeader name="Instructor Details" />
      {listState.isLoading ? (
        <div className="text-center py-5">
          <i className="fas fa-spinner fa-spin fa-2x"></i>
        </div>
      ) : listState.error ? (
        <div className="text-center py-5">
          <p className="text-danger">{listState.error}</p>
        </div>
      ) : (
        <Container className="mt--6" fluid>
          {/* Profile Summary */}
          <Row className="justify-content-center">
            <Col md="5">
              <Card className="section-cards w-100">
                <CardBody className="text-center ">
                  {/* Profile Image */}
                  <Col xs="12" className="text-center ">
                    <FormGroup className="profile-photo-container text-center">
                      <div className="d-inline-block position-relative">
                        {formData.profilePhoto?.value ? (
                          <img
                            src={formData.profilePhoto.value.preview}
                            alt="profilePhoto"
                            className="profile-photo-preview"
                          />
                        ) : (
                          <Avatar name={formData.fullName?.value || ""} />
                        )}
                        <span
                          id="statusDot"
                          className={`status-dot ${
                            formData.accountStatus?.value === "ACTIVE"
                              ? "status-active"
                              : "status-inactive"
                          }`}
                        />

                        <Tooltip
                          placement="top"
                          isOpen={tooltipOpen}
                          target="statusDot"
                          toggle={toggle}
                        >
                          {formData.accountStatus?.value === "ACTIVE"
                            ? "Active"
                            : "Inactive"}
                        </Tooltip>
                      </div>
                      {/* {profileState.isEditing && (
          <>
            <small className="text-muted d-block mt-2">
              Accepted formats: PNG, JPG. Maximum file size: 2 MB.
            </small>
            <span
              className="profile-img-edit cursor"
              onClick={() =>
                document.getElementById("profilePhotoInput").click()
              }
            >
              <i className="fa fa-camera" />
            </span>
            <Input
              type="file"
              id="profilePhotoInput"
              accept="image/png,image/jpeg"
              className="d-none"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file && file.size <= MAX_FILE_SIZE) {
                  handleInputChange("profilePhoto", file);
                }
              }}
            />
          </>
        )} */}
                    </FormGroup>
                  </Col>
                  {/* Name & Contact Info */}
                  {profileState.isEditing ? (
                    <>
                      {/* Contact Chips */}
                      <div className="d-flex justify-content-center align-items-center flex-wrap mb-3 mt-2">
                        <div className="mx-2 my-2">
                          <span className="td-meta-chip">
                            <i className="fas fa-envelope mr-2"></i>
                            {formData.email.value || ""}
                          </span>
                        </div>
                        <div className="mx-2 my-2">
                          <span className="td-meta-chip">
                            <i className="fas fa-phone mr-2"></i>
                            +91 {formData.mobile?.value || ""}
                          </span>
                        </div>
                      </div>

                      <Row>
                        <Col md="6" className="mb-3">
                          <Label className="small-label text-muted mb-1 d-block text-left">
                            First Name
                          </Label>
                          <Input
                            type="text"
                            placeholder="First name"
                            value={formData.firstName?.value || ""}
                            onChange={(e) =>
                              handleChange("firstName", e.target.value)
                            }
                            onBlur={(e) =>
                              handleOnBlur("firstName", e.target.value)
                            }
                          />
                          {formData.firstName?.error && (
                            <small className="invalid-feedback d-block">
                              {formData.firstName.error}
                            </small>
                          )}
                        </Col>
                        <Col md="6">
                          <Label className="small-label text-muted mb-1   d-block  text-left">
                            Last Name
                          </Label>
                          <Input
                            type="text"
                            placeholder="Last name"
                            value={formData.lastName?.value || ""}
                            onChange={(e) =>
                              handleChange("lastName", e.target.value)
                            }
                            onBlur={(e) =>
                              handleOnBlur("lastName", e.target.value)
                            }
                          />
                          {formData.lastName?.error && (
                            <small className="invalid-feedback d-block">
                              {formData.lastName.error}
                            </small>
                          )}
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <h2 className="mb-0 text-default section-title mt-2">
                        {formData.firstName?.value ||
                          instructorProfileData.firstName.value ||
                          ""}{" "}
                        {formData.lastName?.value ||
                          instructorProfileData.lastName.value ||
                          ""}
                      </h2>
                      <div className="d-flex justify-content-center align-items-center flex-wrap mb-3">
                        <div className="mx-2 my-2">
                          <span className="td-meta-chip">
                            <i className="fas fa-envelope mr-2"></i>
                            {formData.email.value ||
                              instructorProfileData.value}
                          </span>
                        </div>
                        <div className="mx-2 my-2">
                          <span className="td-meta-chip">
                            <i className="fas fa-phone mr-2"></i>
                            +91{" "}
                            {formData.mobile?.value ||
                              instructorProfileData.mobile.value}
                          </span>
                        </div>
                      </div>
                    </>
                  )}

                  <Row
                    className={`mb-2 mt-4 ${profileState.isEditing ? "text-left" : "text-center"}`}
                  >
                    <Col md="6">
                      <Label className="small-label text-muted">
                        Prior Years of Experience
                      </Label>

                      {profileState.isEditing ? (
                        <Input
                          type="number"
                          min="0"
                          placeholder="Enter experience in months"
                          value={formData.experienceYears?.value || ""}
                          onChange={(e) =>
                            handleChange("experienceYears", e.target.value)
                          }
                        />
                      ) : (
                        <p className="small-text">
                          {formData.experienceYears?.displayValue || ""}
                        </p>
                      )}
                    </Col>
                    <Col md="6">
                      <label className="small-label text-muted text-left">
                        Gender
                      </label>
                      {profileState.isEditing ? (
                        <Select
                          name="gender"
                          options={GENDER_OPTIONS}
                          placeholder="Select gender"
                          classNamePrefix="react-select"
                          menuPosition="absolute"
                          styles={SELECT_CUSTOM_STYLES}
                          menuPortalTarget={document.body}
                          value={
                            GENDER_OPTIONS.find(
                              (opt) => opt.value === formData.gender.value,
                            ) || null
                          }
                          className={formData.gender.error ? "is-invalid" : ""}
                          onBlur={() =>
                            handleOnBlur("gender", formData.gender.value)
                          }
                          onChange={(selected) =>
                            handleChange("gender", selected?.value || "")
                          }
                          isClearable
                        />
                      ) : (
                        <p className="small-text">
                          {formData.gender?.value ||
                            instructorProfileData.gender.value}
                        </p>
                      )}
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter className="admin-profile-footer text-center">
                  {/* Created On */}
                  <Label
                    className={`small-label text-muted mb-1 ${profileState.isEditing ? "mt-3" : ""}`}
                  >
                    Account Created On
                  </Label>
                  <p
                    className={`small-text ${profileState.isEditing ? "mb--2" : ""}`}
                  >
                    {formData.createdOn?.value || ""}
                  </p>

                  <div className="mt-3" />
                  {/* Buttons */}

                  {!profileState.isEditing ? (
                    <Button
                      className="btn-deep-blue edit-reduced-height"
                      color="primary"
                      size="lg"
                      onClick={handleEdit}
                    >
                      <i className="fa-solid fa-pencil mr-2"></i>
                      Edit Profile
                    </Button>
                  ) : (
                    <>
                      <Button
                        color="secondary"
                        className="mr-2 btn-reduced-height mt-3"
                        size="lg"
                        onClick={handleOnCancel}
                      >
                        Cancel
                      </Button>

                      <Button
                        color="primary"
                        className="btn-deep-blue mr-2 btn-reduced-height mt-3"
                        size="lg"
                        onClick={handleSave}
                      >
                        Save
                      </Button>
                    </>
                  )}
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
}

export default InstructorProfile;
